module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/artillery-battalion-lvl2-100.cd1dc052.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/artillery-battalion-lvl2-100.png
// module id = 3499
// module chunks = 11